import { render, staticRenderFns } from "./TaskPanelDialog.vue?vue&type=template&id=58c9bc16&scoped=true"
import script from "./TaskPanelDialog.vue?vue&type=script&lang=js"
export * from "./TaskPanelDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskPanelDialog.vue?vue&type=style&index=0&id=58c9bc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9bc16",
  null
  
)

export default component.exports